const asset = (key: string, width: number, height: number, alt: string) => ({
  key,
  width,
  height,
  alt,
  avif: `assets/interface/${key}.avif`,
  webp: `assets/interface/${key}.webp`,
});

const mobileVariant = (key: string, width: number, height: number) => ({
  width,
  height,
  avif: `assets/interface/${key}-mobile.avif`,
  webp: `assets/interface/${key}-mobile.webp`,
});

export const INTERFACE_ASSETS = {
  landingCard: {
    ...asset(
      "landing-card",
      960,
      1200,
      "斜めに傾いた標本劇場の通路を奥へ進む匿名の人物を描いた版画調イラスト",
    ),
    mobile: mobileVariant("landing-card", 480, 600),
  },
  resultSample: {
    ...asset(
      "result-sample",
      960,
      960,
      "円形劇場を俯瞰し、双眼鏡と未開花のつぼみ、拍手しない手を配した版画調イラスト",
    ),
    mobile: mobileVariant("result-sample", 480, 480),
  },
  resultCardFrame: {
    ...asset(
      "result-card-frame",
      1200,
      630,
      "診断結果の専用アートと判定文を収める、黒地と古紙で構成した標本劇場の装飾フレーム",
    ),
    compositeRect: {
      left: 55.2,
      top: 16.3,
      width: 36.7,
      height: 71.5,
    },
  },
} as const;
